var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmoLogoSimple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 626,
    height: 200,
    viewBox: "0 0 626 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#41BA8B;}\n  .st1{fill:#F6D211;}\n  .st2{fill:#95CBDF;}\n  .st3{fill:#134545;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 202,
    width: 628,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    d: "m543.09,2.23c-32.36,6.78 -40.54,21.74 -40.54,55.7c27.57,5.38 51.83,20.02 69.41,40.54c18.91,-5.65 35.54,-29.6 28.92,-63.01c-14.51,-17.1 -34.77,-29.18 -57.79,-33.23z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    d: "m501.85,138.41c-5.76,23.41 0,47.51 40.88,57.42c22.94,-3.95 43.17,-15.86 57.72,-32.78c6.38,-24.83 -2.38,-53.91 -28.5,-64.58c-17.82,20.42 -42.32,34.87 -70.1,39.94z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    d: "m501.85,138.41c-4.17,-12.32 -6.43,-25.52 -6.43,-39.25c0,-14.47 2.52,-28.35 7.13,-41.23c-5.13,-9.44 -15.68,-9.44 -23.75,-9.44c-15.86,0 -31.26,0 -44.78,15.68c-4.11,10.83 -6.36,22.57 -6.36,34.84c0,11.28 1.91,22.11 5.4,32.2c13.81,14.3 29.55,17.57 46.07,17.57c7.56,0 15.97,-1.63 22.72,-10.37z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    d: "m121.65,167.63l-55.59,0l-11.17,24.12l-55.09,0l92.91,-185.31l2.54,0l92.91,185.31l-55.08,0l-11.43,-24.12zm-40.87,-34.53l26.4,0c-4.57,-10.66 -11.42,-27.42 -12.95,-34.02l-0.51,0c-1.52,6.61 -8.37,23.36 -12.94,34.02z",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    d: "m267.04,107.46l0,84.28l-50.51,0l0,-185.31l1.27,0l91.13,75.14l90.88,-75.14l1.52,0l0,185.31l-50.77,0l0,-84.28l-41.63,33.76l-41.89,-33.76z",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    d: "m600.46,163.05c14.8,-17.2 23.74,-39.58 23.74,-64.05c0,-24.23 -8.77,-46.41 -23.31,-63.54c-3.42,23.93 -13.75,45.63 -28.92,63.01c15.26,17.82 25.49,40.08 28.49,64.58z",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_8",
    d: "m502.55,57.93c7.96,-22.25 22.18,-41.53 40.54,-55.7c-5.57,-0.98 -11.3,-1.5 -17.16,-1.5c-42,0 -77.84,26.36 -91.91,63.43c13.91,-5.49 29.07,-8.51 44.94,-8.51c8.07,0 15.96,0.79 23.59,2.28z",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_9",
    d: "m501.85,138.41c-7.18,1.31 -14.58,2 -22.14,2c-16.52,0 -32.27,-3.28 -46.65,-9.21c13.33,38.45 49.87,66.06 92.86,66.06c5.73,0 11.34,-0.5 16.8,-1.44c-18.72,-14.56 -33.1,-34.46 -40.87,-57.41z",
    className: "st3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmoLogoSimple);
export default __webpack_public_path__ + "static/media/amoLogo_simple.ae4bb5ea.svg";
export { ForwardRef as ReactComponent };